import { Route, Routes } from 'react-router-dom'
import MarkingPeriodsPage from './Page'

export default function MarkingPeriods() {
  return (
    <Routes>
      <Route path="/" element={<MarkingPeriodsPage />} />
      <Route path="/:id" element={<MarkingPeriodsPage />} />
    </Routes>
  )
}
